import { Box, Flex } from "@edricphan2022/uikit";
import styled from "styled-components";
import Poster1 from "../../assets/Home/slider1.png";
import Poster2 from "../../assets/Home/slider2.png";
import Poster3 from "../../assets/Home/slider3.png";
import Slider from "react-slick";
import InfomationBanner from "./InfomationBanner";

const SliderV2 = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    <Wapper>
      <Content>
        <Slider {...settings}>
          <ContentGroup>
            <TextBox>
              <h1>Wikex Exchange</h1>
              <h2>A quality <br/> outsourcing company</h2>
              <p>
              Orbit is a quality outsourcing company specializing in Website,<br/> Mobile App and Blockchain development.
              </p>
            </TextBox>
            <ImgBox>
              <img src={Poster2} alt="" />
            </ImgBox>
          </ContentGroup>
          <ContentGroup>
            <TextBox>
              <h1>Orbit Technology</h1>
              <h2>provide optimal solution<br/> for our partners</h2>
              <p>
                Modern solution <br/>
                for your company
              </p>
            </TextBox>
            <ImgBox>
              <img src={Poster1} alt="" />
            </ImgBox>
          </ContentGroup>
          <ContentGroup>
            <TextBox>
              <h1>Wikex Exchange</h1>
              <h2>Development <br/> for your product</h2>
              <p>
                We are design agency who specialized in UI/UX Design and Product <br/> Design  based in VietNam
              </p>
            </TextBox>
            <ImgBox>
              <img src={Poster3} alt="" />
            </ImgBox>
          </ContentGroup>
        </Slider>
      </Content>
      <InfomationBanner/>
    </Wapper>
  );
};
const Wapper = styled(Box)`
  width: 100%;
  margin-top: 26px;
`;
const Content = styled(Box)`
  width: 100%;
  overflow: hidden;
`;
const ContentGroup = styled(Flex)`
  width: 100%;
  display: flex !important;
  @media only screen and (max-width: 743px){
    flex-direction: column-reverse;
  }
`;
const TextBox = styled(Box)`
  width: 50%;
  height: 100%;
  min-height: 100%;
  h1,
  h2 {
    color: #f7d644;
    font-size: 64px;
    line-height: 71px;
    font-weight: 700;
    font-family: ManropeBold;
  }
  h2 {
    color: #333333;
    margin-bottom: 1.77vw;
  }
  p {
    color: #333333;
    font-size: 24px;
    font-family: ManropeRegular;
    font-weight: 400;
    line-height: 36px;
  }
  @media only screen and (max-width: 1280px){
    width: 85%;
    min-width: 67%;
    h1, h2{
        font-size: 5vw;
        line-height: 5.55vw;
    }
  }
  @media only screen and (max-width: 1133px){
    h1, h2{
        font-size: 4.236vw;
    }
  }
  @media only screen and (max-width: 820px){
    h1, h2{
        font-size: 4.838vw;
        line-height: 6.45vw;
    }
    p{
        font-size: 14px;
    }
  }
  @media only screen and (max-width: 743px){
    width: 100%;
    max-width: 100%;
    h1 , h2{
        font-size: 36px;
        line-height: 48px;
    }
    P{
        font-size: 17px;
        line-height: 22px;
        margin-top: 10px;
    }
  }
`;
const ImgBox = styled(Box)`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    max-width: 520px;
  }
  @media only screen and (max-width: 743px){
    max-width: 70%;
    margin-bottom: 30px;
  }

`;
export default SliderV2;
